import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import { MainContainer, ChatContainer, ConversationHeader,TypingIndicator, MessageList, Message, MessageInput } from "@chatscope/chat-ui-kit-react";
import { useState } from "react";

export const Widget = ({remoteName = "", messages = [], onSend,typingInd}) => {   
    
    const [active,SetActive] = useState(true);

    function toggleChat (){
        SetActive(!active)
    }
    
    return (
        <MainContainer className={!active?'transparent':""}>
            
            <ChatContainer className={!active?'ddNone':""}>
                <ConversationHeader>
                    <ConversationHeader.Content userName={remoteName} onClick={toggleChat} />
                        
                  
                </ConversationHeader>
                
                <MessageList typingIndicator={typingInd && <TypingIndicator content="HomeWorkHero is typing" />}>
                    {messages.map( message =>
                        <Message key={message._id} model={message} />
                    )}
        
                </MessageList>
        
                <MessageInput placeholder="Type message here"
                              attachButton={false}
                              onSend={onSend}
                />
            </ChatContainer>
        
            <div
            className={active?'ddNone':""}
             style={{
                color: "#ec1212",
                alignSelf: "flex-center",
                position:"fixed",
                right:"10px",
                bottom:"10px",
                zIndex:"999999",
                background:"#2839CC",
                width:"30px",
                height:"30px",
                borderRadius:"50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "20px",
                cursor:"pointer"
              }}
              onClick={toggleChat}
            ><svg width="31" height="32" viewBox="0 0 31 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.5 0C24.0607 0 31 6.93935 31 15.5C31 24.0606 24.0607 31 15.5 31C13.0262 31.0034 10.5878 30.4123 8.39016 29.2764L2.45986 30.9302C2.129 31.0226 1.77954 31.0253 1.44728 30.9381C1.11503 30.8509 0.811927 30.677 0.569033 30.4341C0.326139 30.1912 0.152187 29.8881 0.065 29.5558C-0.0221865 29.2236 -0.0194728 28.8741 0.0728629 28.5432L1.72826 22.6176C0.589558 20.418 -0.00320664 17.9768 1.30463e-05 15.5C1.30463e-05 6.93935 6.93936 0 15.5 0ZM15.5 2.325C12.0058 2.325 8.65467 3.71308 6.18388 6.18387C3.71309 8.65466 2.32501 12.0058 2.32501 15.5C2.32501 17.7785 2.90316 19.9686 3.98816 21.9123L4.22066 22.3308L2.49706 28.506L8.67691 26.7824L9.09541 27.0149C10.8537 27.9925 12.8125 28.5544 14.8216 28.6576C16.8308 28.7608 18.8369 28.4026 20.6861 27.6103C22.5353 26.818 24.1785 25.6128 25.4897 24.087C26.8009 22.5612 27.7453 20.7554 28.2504 18.8081C28.7555 16.8608 28.808 14.8236 28.4038 12.8529C27.9996 10.8821 27.1495 9.03012 25.9185 7.43886C24.6876 5.8476 23.1087 4.55935 21.3027 3.67292C19.4968 2.78648 17.5118 2.32538 15.5 2.325ZM10.4625 17.05H17.4344C17.7289 17.0501 18.0125 17.162 18.2277 17.3631C18.4429 17.5641 18.5738 17.8394 18.5938 18.1333C18.6139 18.4271 18.5217 18.7176 18.3358 18.9461C18.15 19.1746 17.8843 19.324 17.5925 19.3641L17.4344 19.375H10.4625C10.168 19.3749 9.88445 19.263 9.66923 19.0619C9.45402 18.8609 9.32315 18.5856 9.30307 18.2917C9.28299 17.9979 9.37521 17.7074 9.56108 17.4789C9.74695 17.2504 10.0126 17.101 10.3044 17.0608L10.4625 17.05ZM10.4625 11.625H20.5453C20.8397 11.6255 21.1229 11.7376 21.3378 11.9388C21.5528 12.14 21.6833 12.4153 21.7032 12.709C21.7231 13.0028 21.6308 13.2931 21.4449 13.5214C21.259 13.7497 20.9935 13.899 20.7018 13.9391L20.5453 13.95H10.4625C10.168 13.9499 9.88445 13.838 9.66923 13.6369C9.45402 13.4359 9.32315 13.1606 9.30307 12.8667C9.28299 12.5729 9.37521 12.2824 9.56108 12.0539C9.74695 11.8254 10.0126 11.676 10.3044 11.6358L10.4625 11.625Z" fill="white"/>
            </svg>
            </div>
            
        </MainContainer>
    );
};
